var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabinet-rows"},_vm._l((_vm.rows),function(row){return _c('div',{key:row.label,staticClass:"cabinet-rows__row"},[_c('span',[_vm._v(_vm._s(row.label))]),_c('strong',[_vm._v(_vm._s(row.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }